<template>
	<div class="news">
		<div class="wrap container1">
			<div class="header">Nyheder fra Stila</div>
			<div class="box">
				<featured/>
				<items/>
			</div>
		</div>
	</div>
</template>

<script>
import featured from "./featured/index.vue";
import items from "./items/index.vue";

export default {
	components: {featured, items}
};
</script>

<style lang="scss" scoped>
.news {
	position: relative;

	.wrap {
		@include res(mobile) {
			padding: 0;
		}

		.header {
			height: 62px;
			margin-top: -62px;
			background-color: #22313A;
			box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04);
			color: $white1;
			display: flex;
			align-items: center;
			padding: 0 32px;
			font-size: 20px;
			font-weight: 500;

			@include res(mobile) {
				height: 51px;
				margin-top: -51px;
				font-size: 17px;
			}
		}

		.box {
			box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
			background-color: $white1;
			padding: 66px 70px;

			@include res(mobile) {
				padding: 17px 10px;
			}
		}
	}
}
</style>
